import { ApolloError, useMutation } from '@apollo/client'
import { CREATE_COUPON_ORDER_MUTATION } from '@graphql/mutations/createCouponOrder'
import axios from 'axios'
import { useState } from 'react'

import { Coupon, Studio } from '@definitions/types/symfonyTypesd'

type callbackSuccessType = (status: string) => void
type callbackErrorType = () => void

interface useHandleCouponOrderReturnType {
  handleCouponOrder: (
    coupon: Coupon,
    affiliation: string,
    studio: Studio,
    email: string,
    newsletter: boolean
  ) => Promise<void>
  handleCouponOrderError: ApolloError | null
}

const useHandleCouponOrder = (
  onCompleteCallback: callbackSuccessType | null,
  onErrorCallback: callbackErrorType | null
): useHandleCouponOrderReturnType => {
  const [handleCouponOrderError, setHandleCouponOrderError] =
    useState<ApolloError | null>(null)

  const [createCouponOrderMutation] = useMutation(
    CREATE_COUPON_ORDER_MUTATION,
    {
      onCompleted: (data) => {
        if (data && onCompleteCallback) {
          onCompleteCallback(
            data.createCouponOrderPlacement.couponOrderPlacement.status
          )
        }
      },
      onError: (error) => {
        setHandleCouponOrderError(error)
        if (onErrorCallback) {
          onErrorCallback()
        }
        console.log(error)
      },
    }
  )

  const handleCouponOrder = async (
    coupon: Coupon,
    affiliation: string,
    studio: Studio,
    email: string,
    newsletter: boolean
  ): Promise<void> => {
    const variables: any = {
      coupon: coupon.id,
      affiliation: affiliation,
      studio: studio.id,
      customerEmail: email,
    }

    await createCouponOrderMutation({
      variables: {
        input: {
          ...variables,
        },
      },
    })

    if (newsletter) {
      try {
        await axios.post(
          '/api/subscribeMailchimp',
          { list: affiliation.toLowerCase(), email },
          { headers: { 'Content-Type': 'application/json' } }
        )
      } catch (error) {
        // optional newsletter subscription should not cause the whole coupon order to fail
      }
    }
  }

  return {
    handleCouponOrder,
    handleCouponOrderError,
  }
}

export default useHandleCouponOrder
